export const THEMES = {
  DARK: 'DARK'
};

export const ENABLE_REDUX_DEV_TOOLS = true;
 
export const DELIVERY_TYPE = [
  {
    value: 'SL',
    label: 'SL Post'
  },
  {
    value: 'IE',
    label: 'I Express'
  },
];
 
export const COURIER_IDS = [
  '5fe6a7bdcfc793001ddaeb51',
  '656101a7ac6ab7001a329432'
];
